export default __webpack_public_path__ + "static/media/thumb-tb-start-page.0672b204.png";